module.exports = __webpack_public_path__ + "static/media/PayPal.7020fa66.svg";